import React, { useState, useEffect } from 'react';
import './Rol.css';
import InstagramStories from '../Insta/InstagramStories';
import Story from '../Ht/Story';

import image13 from './taffi.jpeg';


// Import other images as needed

const Slider = () => {
    const [currentImage, setCurrentImage] = useState(0);

    const images = [image13,]; // Add other imported images

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prevImage) => (prevImage + 1) % images.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [currentImage, images.length]);

    const handlePrev = () => {
        setCurrentImage((prevImage) => (prevImage - 1 + images.length) % images.length);
    };

    const handleNext = () => {
        setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    };

    return (
        <div id="sliderMainContainer">
            <div className="slider-container">
                <button onClick={handlePrev} className="slider-button1">
                    &lt;
                </button>
                <img src={images[currentImage]} alt={`Slide ${currentImage}`} className="slider-image" />
                <button onClick={handleNext} className="slider-button2">
                    &gt;
                </button>

                <h2 id='Gale'>علاجاتنا</h2>

                <InstagramStories />
                <Story />
            </div>
        </div>
    );
};

export default Slider;
